import { PageContainer, Card, Table, Button, Badge } from '@aimsos/ui';
import { UserPlus, RefreshCw } from 'lucide-react';

const INVITATIONS = [
  { id: 1, email: 'frank@company.com', role: 'Editor', status: 'Pending', sentBy: 'alice@company.com', expiresAt: '2024-10-19' },
  { id: 2, email: 'grace@company.com', role: 'Viewer', status: 'Pending', sentBy: 'bob@company.com', expiresAt: '2024-10-20' },
  { id: 3, email: 'henry@company.com', role: 'Admin', status: 'Expired', sentBy: 'alice@company.com', expiresAt: '2024-10-05' },
  { id: 4, email: 'iris@company.com', role: 'Viewer', status: 'Accepted', sentBy: 'dave@company.com', expiresAt: '2024-10-15' },
];

const statusVariant = { Pending: 'warning', Accepted: 'success', Expired: 'danger' };

const COLUMNS = [
  { key: 'email', label: 'Email', sortable: true },
  { key: 'role', label: 'Role' },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    render: (val) => <Badge variant={statusVariant[val]}>{val}</Badge>,
  },
  { key: 'sentBy', label: 'Sent By' },
  { key: 'expiresAt', label: 'Expires', sortable: true },
  {
    key: 'id',
    label: '',
    render: (_val, row) =>
      row.status === 'Pending' ? (
        <Button variant="ghost" size="sm" leftIcon={RefreshCw}>Resend</Button>
      ) : null,
  },
];

const Invitations = () => (
  <PageContainer
    title="Invitations"
    actions={<Button leftIcon={UserPlus}>New Invitation</Button>}
  >
    <Card>
      <Card.Header
        title="All Invitations"
        description={`${INVITATIONS.length} invitations`}
      />
      <Card.Body className="p-0">
        <Table columns={COLUMNS} data={INVITATIONS} />
      </Card.Body>
    </Card>
  </PageContainer>
);

export default Invitations;
